module.exports = __webpack_public_path__ + "static/media/call-auth-history.470b48e0.png";